import { useState } from 'react'

const LOGS = [
  { id: 'day_log', label: 'Day Log', description: 'Watch entries — weather, position, significant events', icon: '📋', available: true },
  { id: 'engine_log', label: 'Engine Room Log', description: 'Engine hours, fuel consumption, machinery status', icon: '⚙️', available: true },
  { id: 'running_log', label: 'Running Log', description: 'Voyage entries — hourly position, weather, courses and speed', icon: '🗺️', available: true },
  { id: 'oil_record_book', label: 'Oil Record Book', description: 'Part I machinery space operations — sludge, bilge water, bunkering (MARPOL Annex I)', icon: '🛢️', available: true },
  { id: 'drill_log', label: 'Drill Log', description: 'Fire, flooding, MOB drill records', icon: '🚨', available: true },
  { id: 'defect_log', label: 'Defect Report', description: 'Crew defect reporting and resolution tracking', icon: '🔧', available: false },
]

export default function LogBooks({ onNavigate }) {
  const [selected, setSelected] = useState(null)

  return (
      <div style={{ flex: 1, padding: 32 }}>
          <p style={{ color: 'var(--muted)', fontSize: 14, marginTop: 0 }}>
            Select a log book to view and add entries.
          </p>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))', gap: 16, marginTop: 24 }}>
            {LOGS.map(log => (
              <div
                key={log.id}
                onClick={() => log.available && onNavigate(log.id)}
                style={{
                  background: 'var(--surface2)',
                  border: `1px solid ${selected === log.id ? 'var(--gold)' : 'var(--border)'}`,
                  borderRadius: 12,
                  padding: 20,
                  cursor: log.available ? 'pointer' : 'default',
                  opacity: log.available ? 1 : 0.5,
                  transition: 'border-color .2s',
                }}
                onMouseEnter={e => { if (log.available) e.currentTarget.style.borderColor = 'var(--gold)' }}
                onMouseLeave={e => { if (log.available) e.currentTarget.style.borderColor = 'var(--border)' }}
              >
                <div style={{ fontSize: 28, marginBottom: 10 }}>{log.icon}</div>
                <div style={{ fontWeight: 600, fontSize: 15, marginBottom: 6 }}>{log.label}</div>
                <div style={{ fontSize: 12, color: 'var(--muted)', lineHeight: 1.5 }}>{log.description}</div>
                {!log.available && (
                  <div style={{ marginTop: 10, fontSize: 11, color: 'var(--muted)', fontStyle: 'italic' }}>Coming soon</div>
                )}
              </div>
            ))}
          </div>
      </div>
  )
}
